import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/** HttpClient that bypasses angular-in-memory-web-api for real backend calls. */
export const REAL_HTTP_CLIENT = new InjectionToken<HttpClient>('REAL_HTTP_CLIENT');
